/**
 * @function skipNavigation
 * @param  {Object} event Keyboard interaction event
 */
export default function skipNavigation (event) {
    event.preventDefault()

    const main = document.querySelector('.js-main')
    const focusables = [...main.querySelectorAll('a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')]
    const [firstFocusable] = focusables

    firstFocusable.focus()
}
